// src/components/forms/bookingFormConstants.ts

export const BOOKING_STATUSES = [
  'Quotation',
  'Pending',
  'Confirmed',
  'CheckedIn',
  'CheckedOut',
  'Cancelled',
] as const;

export type BookingStatus = (typeof BOOKING_STATUSES)[number];

// Quotes are made and edited on the Quote page, so the booking form only
// offers Quotation when the record it is editing already is one.
export const BOOKING_FORM_STATUSES = BOOKING_STATUSES.filter(
  (s) => s !== 'Quotation'
);

export const RATE_TYPES = ['Single', 'Sharing', 'Custom'] as const;
export type RateType = (typeof RATE_TYPES)[number];

export const GROOMING_TYPES = ['Smooth', 'Long', 'Cut'] as const;
export type GroomingType = (typeof GROOMING_TYPES)[number];
